import _defineProperty from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _everyInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/every";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _Object$entries from "@babel/runtime-corejs3/core-js-stable/object/entries";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { DATA_TYPE_OBJECT, dateValueShape, dataTypeShapeWithDateTime, intlMessageShape, nestedTooltipShape } from '@jutro/prop-types';
import { publish, JUTRO_TOPICS } from '@jutro/events';
import { FieldComponent, DateField } from '@jutro/components';
import { Grid } from '@jutro/layout';
import { TimeField } from '../TimeField/TimeField';
import { formatValueFromDataType, formatValueToDataType, isValidDate, isValidTime } from './helpers';
import styles from "./DateTimeField.module.css";
function splitProps(props) {
  var _context;
  return _reduceInstanceProperty(_context = _Object$entries(props)).call(_context, ({
    dateProps,
    timeProps
  }, [key, value]) => {
    let newDateProps = dateProps;
    let newTimeProps = timeProps;
    if (key.match(/Time/)) {
      newTimeProps = _objectSpread({
        [key.replace('Time', '')]: value
      }, timeProps);
    } else {
      newDateProps = _objectSpread({
        [key]: value
      }, dateProps);
    }
    return {
      dateProps: newDateProps,
      timeProps: newTimeProps
    };
  }, {
    timeProps: {},
    dateProps: {}
  });
}
export const DateTimeField = props => {
  const id = props.id,
    onValueChange = props.onValueChange,
    dataType = props.dataType,
    value = props.value,
    defaultValue = props.defaultValue,
    model = props.model,
    path = props.path,
    showTime = props.showTime,
    dataPath = props.dataPath,
    className = props.className,
    hideLabel = props.hideLabel,
    hideLabelTime = props.hideLabelTime,
    disabled = props.disabled,
    readOnly = props.readOnly,
    isClearable = props.isClearable,
    labelClassName = props.labelClassName,
    secondaryLabelClassName = props.secondaryLabelClassName,
    controlClassName = props.controlClassName,
    labelPosition = props.labelPosition,
    phone = props.phone,
    phoneWide = props.phoneWide,
    tablet = props.tablet,
    timeIntervals = props.timeIntervals,
    timeFormat = props.timeFormat,
    other = _objectWithoutProperties(props, ["id", "onValueChange", "dataType", "value", "defaultValue", "model", "path", "showTime", "dataPath", "className", "hideLabel", "hideLabelTime", "disabled", "readOnly", "isClearable", "labelClassName", "secondaryLabelClassName", "controlClassName", "labelPosition", "phone", "phoneWide", "tablet", "timeIntervals", "timeFormat"]);
  const _splitProps = splitProps(other),
    dateProps = _splitProps.dateProps,
    timeProps = _splitProps.timeProps;
  const compositeValue = formatValueFromDataType(value, showTime);
  useEffect(() => {
    if (!value && defaultValue) {
      const newValue = formatValueFromDataType(defaultValue, showTime);
      handleChange(newValue);
    }
    publish(JUTRO_TOPICS.COMPONENT_LOADED, FieldComponent.fieldEventFormatter(_objectSpread({
      componentName: DateTimeField.displayName
    }, props)));
  }, []);
  const isAllLabelsHidden = useMemo(() => {
    var _context2;
    return _everyInstanceProperty(_context2 = [hideLabel, hideLabelTime]).call(_context2, flag => flag);
  }, [hideLabel, hideLabelTime]);
  const handleChange = val => {
    let newValue = _objectSpread({}, compositeValue, {}, val);
    if (isClearable && !val) {
      newValue = undefined;
    }
    const formattedValue = formatValueToDataType(newValue, dataType, showTime);
    if (!onValueChange) {
      return;
    }
    onValueChange(formattedValue, model || path, {
      id,
      dataPath
    });
    publish(JUTRO_TOPICS.VALUE_CHANGED, FieldComponent.fieldEventFormatter(_objectSpread({}, props, {
      value: formattedValue
    })));
  };
  const renderDateField = () => {
    let selectedValue;
    if (isValidDate(compositeValue)) {
      const year = compositeValue.year,
        month = compositeValue.month,
        day = compositeValue.day;
      selectedValue = {
        year,
        month,
        day
      };
    }
    const onChange = newValue => {
      if (!newValue) {
        handleChange(undefined);
        return;
      }
      const year = newValue.year,
        month = newValue.month,
        day = newValue.day;
      handleChange({
        year,
        month,
        day
      });
    };
    const dateFieldProps = _objectSpread({
      disabled,
      readOnly,
      isClearable,
      secondaryLabelClassName,
      controlClassName,
      labelPosition,
      phone,
      phoneWide,
      tablet
    }, dateProps, {
      id: `${id}-dateField`,
      dataType: DATA_TYPE_OBJECT,
      value: selectedValue,
      onValueChange: onChange,
      showTime: false,
      hideLabel: isAllLabelsHidden,
      labelClassName: cx({
        [styles.hideVisibility]: hideLabel
      }, labelClassName)
    });
    return React.createElement(DateField, dateFieldProps);
  };
  const renderTimeField = () => {
    let selectedValue;
    if (isValidTime(compositeValue)) {
      const hour = compositeValue.hour,
        minute = compositeValue.minute;
      selectedValue = {
        hour,
        minute
      };
    }
    const onChange = newValue => {
      if (!newValue) {
        handleChange(undefined);
        return;
      }
      const hour = newValue.hour,
        minute = newValue.minute;
      handleChange({
        hour,
        minute
      });
    };
    const timeFieldProps = _objectSpread({
      disabled,
      readOnly,
      isClearable,
      secondaryLabelClassName,
      controlClassName,
      labelPosition,
      phone,
      phoneWide,
      tablet
    }, timeProps, {
      timeIntervals,
      timeFormat,
      id: `${id}-timeField`,
      value: selectedValue,
      onValueChange: onChange,
      hideLabel: isAllLabelsHidden,
      labelClassName: cx({
        [styles.hideVisibility]: hideLabelTime
      }, labelClassName)
    });
    return React.createElement(TimeField, timeFieldProps);
  };
  const gridColumns = useMemo(() => labelPosition === 'top' && showTime ? ['2fr', '1fr'] : [], [labelPosition, showTime]);
  return React.createElement(Grid, {
    columns: gridColumns,
    phone: {
      columns: []
    },
    className: className
  }, renderDateField(), showTime && renderTimeField());
};
DateTimeField.displayName = 'DateTimeField';
DateTimeField.propTypes = _objectSpread({}, TimeField.propTypes, {}, DateField.propTypes, {
  dataType: dataTypeShapeWithDateTime.isRequired,
  value: dateValueShape,
  defaultValue: dateValueShape,
  showTime: PropTypes.bool,
  onTimeBlur: PropTypes.func,
  onTimeFocus: PropTypes.func,
  requiredTime: PropTypes.bool,
  showErrorsTime: PropTypes.bool,
  showRequiredTime: PropTypes.bool,
  showOptionalTime: PropTypes.bool,
  labelTime: intlMessageShape,
  secondaryLabelTime: intlMessageShape,
  hideLabelTime: PropTypes.bool,
  tooltipTime: PropTypes.oneOfType([PropTypes.string, nestedTooltipShape]),
  placeholderTime: intlMessageShape
});
DateTimeField.defaultProps = _objectSpread({}, TimeField.defaultProps, {}, DateField.defaultProps, {
  dataType: DATA_TYPE_OBJECT,
  showTime: true
});
DateTimeField.__docgenInfo = {
  componentName: "DateTimeField",
  packageName: "@jutro/lab-preview-date",
  description: "",
  displayName: "DateTimeField",
  methods: [],
  actualName: "DateTimeField",
  metadataType: "field",
  props: {
    dataType: {
      type: {
        name: "enum",
        value: [{
          value: "'object'",
          computed: false
        }, {
          value: "'string'",
          computed: false
        }, {
          value: "'date-time'",
          computed: false
        }]
      },
      required: false,
      description: "Returned data type",
      defaultValue: {
        value: "'object'",
        computed: false
      }
    },
    value: {
      type: {
        name: "union",
        value: [{
          name: "number"
        }, {
          name: "string"
        }, {
          name: "instanceOf",
          value: "Date"
        }, {
          name: "shape",
          value: {
            year: {
              name: "number",
              required: true
            },
            month: {
              name: "number",
              required: true
            },
            day: {
              name: "number",
              required: true
            },
            hour: {
              name: "number",
              required: false
            },
            minute: {
              name: "number",
              required: false
            }
          }
        }]
      },
      required: false,
      description: "Date and time to display"
    },
    defaultValue: {
      type: {
        name: "union",
        value: [{
          name: "number"
        }, {
          name: "string"
        }, {
          name: "instanceOf",
          value: "Date"
        }, {
          name: "shape",
          value: {
            year: {
              name: "number",
              required: true
            },
            month: {
              name: "number",
              required: true
            },
            day: {
              name: "number",
              required: true
            },
            hour: {
              name: "number",
              required: false
            },
            minute: {
              name: "number",
              required: false
            }
          }
        }]
      },
      required: false,
      description: "Set the default field value on render if there is a default value; needs onValueChange to work"
    },
    showTime: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Show timepicker",
      defaultValue: {
        value: "true",
        computed: false
      }
    },
    onTimeBlur: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback when blur event is fired in time picker"
    },
    onTimeFocus: {
      type: {
        name: "func"
      },
      required: false,
      description: "Callback when focus event is fired in time picker"
    },
    requiredTime: {
      type: {
        name: "bool"
      },
      required: false,
      description: "If true, time picker is required"
    },
    showErrorsTime: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Show errors for time picker"
    },
    showRequiredTime: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Show required indicator for time picker"
    },
    showOptionalTime: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Show optional indicator for time picker"
    },
    labelTime: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "shape",
          value: {
            id: {
              name: "string",
              required: false
            },
            defaultMessage: {
              name: "string",
              required: false
            },
            args: {
              name: "shape",
              value: {},
              required: false
            }
          }
        }]
      },
      required: false,
      description: "Intl message for time picker label"
    },
    secondaryLabelTime: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "shape",
          value: {
            id: {
              name: "string",
              required: false
            },
            defaultMessage: {
              name: "string",
              required: false
            },
            args: {
              name: "shape",
              value: {},
              required: false
            }
          }
        }]
      },
      required: false,
      description: "Intl message for time picker label"
    },
    hideLabelTime: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Hides the label on any layout for time picker"
    },
    tooltipTime: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "custom",
          raw: "nestedTooltipShape"
        }]
      },
      required: false,
      description: "Tooltip for time picker"
    },
    placeholderTime: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "shape",
          value: {
            id: {
              name: "string",
              required: false
            },
            defaultMessage: {
              name: "string",
              required: false
            },
            args: {
              name: "shape",
              value: {},
              required: false
            }
          }
        }]
      },
      required: false,
      description: "Intl message for time picker placeholder"
    }
  },
  composes: ["../TimeField/TimeField", "@jutro/components"]
};